import * as React from "react";
const SvgShell = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", ...props }, /* @__PURE__ */ React.createElement("title", null, "file_type_shell"), /* @__PURE__ */ React.createElement("path", { d: "M29.4,27.6H2.5V4.5H29.4Zm-25.9-1H28.4V5.5H3.5Z", style: {
  fill: "#d9b400"
} }), /* @__PURE__ */ React.createElement("polygon", { points: "6.077 19.316 5.522 18.484 10.366 15.255 5.479 11.184 6.12 10.416 12.035 15.344 6.077 19.316", style: {
  fill: "#d9b400"
} }), /* @__PURE__ */ React.createElement("rect", { x: 12.7, y: 18.2, width: 7.8, height: 1, style: {
  fill: "#d9b400"
} }), /* @__PURE__ */ React.createElement("rect", { x: 2.5, y: 5.5, width: 26.9, height: 1.9, style: {
  fill: "#d9b400"
} }));
export default SvgShell;
